import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';

const TrafficTotalContext = createContext(null);

export function SwItsRoadTrafficTotalProvider({ children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("newdashboard/roadtraffic/GetSpeed");
            if (response.status === 200) {
                const data = response.data;
                setCurrentData({
                    updateTime: data.updateTime,
                    totalSmooth: data.totalSmooth,
                    totalSlow: data.totalSlow,
                    totalJammed: data.totalJammed,
                    roads: data.rows.map(row => ({
                        linkNm: row.linkNm, // 도로명
                        // trfStat: row.trfStat, // 
                        speed: row.speed, // 평균 통행속도 
                        rangeSpeed: row.rangeSpeed, // 평균 통행속도 
                        smooth: row.smooth, // 원할구간
                        slow: row.slow, // 서행구간
                        jammed: row.jammed, // 정체 및 혼잡구간간
                    }))
                });
            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <TrafficTotalContext.Provider value={currentData}>
            {children}
        </TrafficTotalContext.Provider>
    );
}
export function SwItsRoadTrafficRight() {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    return (
        <div className='right flx flx_col gap10 j_spc_btw'>
            <div className='spdLi flx a_center j_spc_btw'>
                <p className='spdCirc gr'>원활</p>
                <div className='flx a_center j_flx_end a_flx_end'>
                    <span style={{ fontSize: 'var(--ft-56)', fontWeight: '600', color: 'var(--iv-05)' }}>{currentData.totalSmooth.toLocaleString()}</span>&nbsp;
                    <span className='unit' style={{ marginBottom: '10px' }}>개 구간</span>
                </div>
            </div>
            <div className='spdLi flx a_center j_spc_btw'>
                <p className='spdCirc yl'>지체</p>
                <div className='flx a_center j_flx_end a_flx_end'>
                    <span style={{ fontSize: 'var(--ft-56)', fontWeight: '600', color: 'var(--iv-04)' }}>{currentData.totalSlow.toLocaleString()}</span>&nbsp;
                    <span className='unit' style={{ marginBottom: '10px' }}>개 구간</span>
                </div>
            </div>
            <div className='spdLi flx a_center j_spc_btw'>
                <p className='spdCirc red'>정체</p>
                <div className='flx a_center j_flx_end a_flx_end'>
                    <span style={{ fontSize: 'var(--ft-56)', fontWeight: '600', color: 'var(--iv-02)' }}>{currentData.totalJammed.toLocaleString()}</span>&nbsp;
                    <span className='unit' style={{ marginBottom: '10px' }}>개 구간</span>
                </div>
            </div>
        </div>
    );
}

// 주요도로 혼잡상태 
export function SwItsRoadTrafficGrid() {
    const colorMap = {
        green: 'var(--iv-05)',
        yellow: 'var(--iv-04)',
        red: 'var(--iv-02)',
    };
    const getSpeedColor = (speed) => {
        if (speed < 15) return colorMap.red;
        if (speed <= 25) return colorMap.yellow;
        return colorMap.green;
    };
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    const filteredRoads = [...currentData.roads].sort((a, b) => {
        if (b.jammed !== a.jammed) return b.jammed - a.jammed;
        return b.speed - a.speed;
    });

    return (
        <div className='grid rdTrfgrid flx flx_col'>
            <div className='gridTitLi flx a_center j_spc_btw'>
                <p className='rdNm'>주요도로</p>
                <p className='dly'>정체구간</p>
                <p className='spd'>평균속도</p>
                <p className='rngSpd'>월평균</p>
            </div>
            <div className='gridBox cst_scroll'>
                {filteredRoads.map((road, index) => (
                    <div key={index} className='gridLi flx flx_col a_flx_st'>
                        <div className='flx a_center j_spc_btw'>
                            <p className='rdNm'>{road.linkNm}</p>
                            <p className='white-80 flx a_flx_end j_flx_end dly' style={{ fontSize: 'var(--ft-26)' }}>
                                <span className='white-50' style={{ fontSize: 'var(--ft-36)', fontWeight: 'var(--ft-Medium)', margin: '0 6px -4px 20px' }}>{road.jammed.toLocaleString()}</span>
                                <span className='unit' style={{ fontSize: 'var(--ft-24)', marginBottom: '0' }}>개</span>
                            </p>
                            {/* <p className='white-80 flx a_flx_end j_flx_end spd' style={{ fontSize: 'var(--ft-26)', fontWeight: 'var(--ft-Medium)' }}>
                                <span className='white' style={{ fontSize: 'var(--ft-36)', fontWeight: 'var(--ft-Medium)', margin: '0 6px -4px 20px' }}>{road.speed.toFixed(1)}</span>
                                <span className='unit' style={{ fontSize: 'var(--ft-24)', marginBottom: '0' }}>km/h</span>
                            </p> */}
                            <p className='white-80 flx a_flx_end j_flx_end spd' style={{ fontSize: 'var(--ft-26)', fontWeight: 'var(--ft-Medium)' }}>
                                <span
                                    className='white'
                                    style={{
                                        fontSize: 'var(--ft-36)',
                                        fontWeight: 'var(--ft-Medium)',
                                        margin: '0 6px -4px 20px',
                                        color: getSpeedColor(road.speed),
                                    }}
                                >
                                    {road.speed.toFixed(1)}
                                </span>
                                <span className='unit' style={{ fontSize: 'var(--ft-24)', marginBottom: '0' }}>km/h</span>
                            </p>
                            {/* <p className='white-80 flx a_flx_end j_flx_end rngSpd' style={{ fontSize: 'var(--ft-26)', fontWeight: 'var(--ft-Medium)' }}>
                                <span className='white' style={{ fontSize: 'var(--ft-36)', fontWeight: 'var(--ft-Medium)', margin: '0 6px -4px 20px' }}> {road.rangeSpeed?.toFixed(1)}</span>
                                <span className='unit' style={{ fontSize: 'var(--ft-24)', marginBottom: '0' }}>km/h</span>
                            </p> */}
                            <p className='white-80 flx a_flx_end j_flx_end rngSpd' style={{ fontSize: 'var(--ft-26)', fontWeight: 'var(--ft-Medium)' }}>
                                <span
                                    className='white'
                                    style={{
                                        fontSize: 'var(--ft-36)',
                                        fontWeight: 'var(--ft-Medium)',
                                        margin: '0 6px -4px 20px',
                                        color: getSpeedColor(road.rangeSpeed),
                                    }}
                                >
                                    {road.rangeSpeed?.toFixed(1)}
                                </span>
                                <span className='unit' style={{ fontSize: 'var(--ft-24)', marginBottom: '0' }}>km/h</span>
                            </p>

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
